export const BASE_API_URL = process.env.REACT_APP_API_URL;
export const CFT_INSTALL_DOC_LINK =
  'https://docs.deepfactor.io/hc/en-us/articles/360052479194';
export const OVA_INSTALL_DOC_LINK =
  'https://docs.deepfactor.io/hc/en-us/articles/360052676033';
export const KUBERNETES_INSTALL_DOC_LINK =
  'https://docs.deepfactor.io/hc/en-us/articles/1500008972502';
